import { TramitadorFilter } from './tramitador.filter';
export class Tramitacio {
  listDenuncies: any[];
  fechaInicio: Date;
  fechaFin: Date;
  matriculasExtrangeras: boolean;
  incloureImatges: boolean;
}
